import { useFooterMenuList } from 'hooks/footerMenuList';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-navi';
import { ALLOWED_DOMAINS, awardsImages } from './helper';

import { LanguageSwitcher } from 'components/LanguageSwitcher';
import { ScContainer } from 'components/styles/common';
import {
  ScAddons,
  ScAwards,
  ScCopyright,
  ScFooter,
  ScLicenses,
  ScNav,
} from './styled';

import askGamblers from 'assets/images/askGamblers.svg';
import casinoOnlineLogo from 'assets/images/casinoOnlineApproved.svg';
import casinosAnalyzer from 'assets/images/casinosAnalyzer.png';
import playResponsibly from 'assets/images/playResponsibly.svg';
import sealLogo from 'assets/images/seal.svg';
import { ReactComponent as TgIcon } from 'assets/images/socialNetworks/telegram-icon.svg';
import { ReactComponent as WaIcon } from 'assets/images/socialNetworks/whats-app-icon.svg';

import { useIsAustralia } from 'hooks/useIsAustralia';
import { useIsLibergos } from 'hooks/useIsLibergos';
import { isAULocale } from 'modules/promoLandings/helpers/common';
import { DownloadButtons } from './components/DownloadButtons';
import { ImageComponent } from 'components/Image';

export const TELEGRAM_URL = 'https://t.me/luckyelf';
export const WHATSAPP_URL =
  'https://whatsapp.com/channel/0029VaAmwZA17EmygmFiP13w';

export const Footer = () => {
  const {
    i18n: { language },
  } = useTranslation();
  const isAustralia = useIsAustralia();
  const isAustralianLanguage = isAULocale(language);
  const isLibergos = useIsLibergos();

  const showFooterCopyright = isLibergos
    ? true
    : !isAustralia && !isAustralianLanguage;

  return (
    <ScFooter>
      <ScContainer>
        <Awards />
        <Nav />
        <div className="footer-bottom-box">
          {showFooterCopyright && <Copyright />}
          <div className="footer-bottom">
            <Licenses />
            <Addons />
          </div>
        </div>
      </ScContainer>
    </ScFooter>
  );
};

const Nav = () => {
  const { t } = useTranslation();

  const footerMenuList = useFooterMenuList();

  return (
    <ScNav>
      <ul>
        {footerMenuList.map(({ name, url, onClick, isHidden }, index) => {
          return (
            !isHidden && (
              <li key={index}>
                <Link href={url} onClick={onClick}>
                  {name}
                </Link>
              </li>
            )
          );
        })}
        <li>
          <button type="button" id="intercomcustomLauncher">
            {t('glossary:helpdesk')}
          </button>
        </li>
      </ul>
    </ScNav>
  );
};

const Copyright = () => {
  const currentFullYear = new Date().getFullYear();

  const isLibergos = useIsLibergos();

  return (
    <ScCopyright>
      <Link
        className="license-link"
        target="_blank"
        href="https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJbEl3WmpocU9YaHlha1JOVEdOc2FFMU5ObXR6V1VFOVBTSXNJblpoYkhWbElqb2lUSEU0VDJKd2RYVkhVekZ3ZEhodFRGUmtTbkZ5VmpSdFVtUmtOek0wT0cxaVRtVmlVbVJIUkhsUmF6MGlMQ0p0WVdNaU9pSTFNMlJoWlRZMFlqTmhNVFJsWkdZd00yVXlaV0V5WWpBd1lqVXhNVE0zWXpKak9XRXhOakl4TWpBMk1UQXdZVEkxTldaaVlUSTNNVFUzTUdRek9EQTFJaXdpZEdGbklqb2lJbjA9"
      >
        <ImageComponent width={77} height={44} src={sealLogo} alt="GCB" />
      </Link>
      <div className="copyright">
        <Trans
          ns="common"
          i18nKey={isLibergos ? 'footer.copyrightLibergos' : 'footer.copyright'}
          values={{ year: currentFullYear }}
        />
      </div>
    </ScCopyright>
  );
};

const Addons = () => {
  const { t } = useTranslation('common');

  return (
    <ScAddons>
      <div className="col">
        <LanguageSwitcher />
      </div>
      <DownloadButtons />
      <div className="col">
        <div className="social-network-box">
          <span>{t('socialNetworks.followUs')}</span>
          <Link target={'_blank'} href={TELEGRAM_URL}>
            <TgIcon />
          </Link>
          <Link target={'_blank'} href={WHATSAPP_URL}>
            <WaIcon />
          </Link>
        </div>
      </div>
    </ScAddons>
  );
};

export const Licenses = () => {
  const isAllowedDomain = ALLOWED_DOMAINS.includes(window.location.hostname);
  return (
    <ScLicenses>
      <div className="licenses">
        <div>
          <Link
            target={'_blank'}
            href="https://luckyelfcasino.com/responsible-gaming"
          >
            <ImageComponent
              width={150}
              height={44}
              src={playResponsibly}
              alt="play responsibly"
            />
          </Link>
        </div>
        {isAllowedDomain && (
          <div>
            <Link
              target={'_blank'}
              href="https://casinosanalyzer.com/free-spins-no-deposit"
            >
              <ImageComponent
                width={107}
                height={44}
                src={casinosAnalyzer}
                alt="casinosAnalyzer"
              />
            </Link>
          </div>
        )}
        <div>
          <Link
            target={'_blank'}
            href="https://www.casino-on-line.com/review/lucky-elf-casino/"
          >
            <ImageComponent
              width={188}
              height={44}
              src={casinoOnlineLogo}
              alt="casino-on-line"
            />
          </Link>
        </div>
        <div>
          <Link
            target={'_blank'}
            href="https://www.askgamblers.com/online-casinos/reviews/lucky-elf-casino"
          >
            <ImageComponent
              width={133}
              height={44}
              src={askGamblers}
              alt="ask gamblers"
            />
          </Link>
        </div>
      </div>
    </ScLicenses>
  );
};

const Awards = () => {
  return (
    <ScAwards>
      {awardsImages.map(({ src, alt }, index) => (
        <ImageComponent
          width={202}
          height={44}
          src={src}
          alt={alt}
          key={index}
        />
      ))}
    </ScAwards>
  );
};
